import { render, staticRenderFns } from "./MarketCategoryTable.vue?vue&type=template&id=7f9b877f"
import script from "./MarketCategoryTable.vue?vue&type=script&lang=js"
export * from "./MarketCategoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports